import React from 'react';
import { HashRouter, Route, Switch} from 'react-router-dom';
import AuthComponent from './components/AuthComponent/AuthComponent'
import Categorias from './views/Categorias/Categorias';
import Profesionales from './views/Profesionales/Profesionales';

function App() {
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/auth" name="Login Page" component={AuthComponent} />
        <Route exact path="/profesionales" name="Login Page" component={Profesionales} />
        <Route exact path="/categorias" name="Login Page" component={Categorias} />
      </Switch>
    </HashRouter>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js